import * as bulmaToast from "bulma-toast";
import api from "../api/api";

// Presence is reported for as long as someone is logged in, not only while the map is
// open: a courier spends the drive on the orders list, and the dispatcher watching the
// map still needs their marker to move. One fix a minute is all a write needs, so the
// app level polls instead of holding the GPS awake for a whole shift.
const REPORT_INTERVAL = 60000;

let pollTimer = null;
let lastReportedAt = 0;
// Once permission is denied every tick fails; one toast is enough.
let reportedFailure = false;

/**
 * Send a fix, unless one already went out this interval. Also called by the map, which
 * keeps a live watch of its own while it is open: its fixes satisfy the throttle, so
 * the poll below never wakes the GPS a second time for the same minute.
 */
export const reportLocation = coords => {
    if (Date.now() - lastReportedAt < REPORT_INTERVAL) return;
    // Stamped before the request, not after it: a standing courier still reports every
    // interval, because last_seen_at is what keeps them on the map at all.
    lastReportedAt = Date.now();
    api.post("/map/location", {lat: coords.lat, long: coords.lng});
};

const poll = () => {
    if (Date.now() - lastReportedAt < REPORT_INTERVAL) return;
    navigator.geolocation.getCurrentPosition(
        position => {
            reportedFailure = false;
            reportLocation({lat: position.coords.latitude, lng: position.coords.longitude});
        },
        () => {
            if (reportedFailure) return;
            reportedFailure = true;
            bulmaToast.toast({type: "is-danger", message: "Не може да се добие локација"});
        },
        // A minute-old fix says just as much about presence as a fresh one, and reusing
        // one keeps the GPS asleep.
        {enableHighAccuracy: true, maximumAge: REPORT_INTERVAL, timeout: 20000}
    );
};

export const startReportingLocation = () => {
    // Started once per login, but guard anyway - two polls would double the writes.
    if (pollTimer !== null) return;
    if (!("geolocation" in navigator)) {
        bulmaToast.toast({type: "is-danger", message: "Не може да се добие локација"});
        return;
    }
    poll();
    pollTimer = setInterval(poll, REPORT_INTERVAL);
};

export const stopReportingLocation = () => {
    clearInterval(pollTimer);
    pollTimer = null;
    lastReportedAt = 0;
    reportedFailure = false;
};
